"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var SideDrawerButton_less_1 = __importDefault(require("./SideDrawerButton.less"));
var SideDrawerButton = function (_a) {
    var className = _a.className, onClick = _a.onClick;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(className, SideDrawerButton_less_1.default['side-drawer-button']), onClick: onClick },
        react_1.default.createElement(react_2.default, { name: 'chevron-back', className: SideDrawerButton_less_1.default['icon'] })));
};
exports.default = SideDrawerButton;
